// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"e3553d55","184":"5d9cd11d","213":"6d4ad8b0","402":"84f499ae","433":"65b3b32d","626":"6a732717","748":"2cd92cfc","749":"85478b89","793":"ed81a3ce","952":"1e5e3821","972":"75857df8"}[chunkId] + ".chunk.js";
};